import { serviceApi, withServiceRequestDefaults } from 'Shared/network';
import dayjs from 'dayjs';
import type { GetPostViewingOverviewResponseDto } from 'viewup-api/v2';
import { serverStatusMapToClientStatus } from '../../model/helper';
import type { PostCampaign, PostCampaignStatus } from '../../model/types';

export type GetPostCampaignOverviewReq = {
  accountUuid: string;
};

type Overview = Omit<PostCampaign, 'typeCode'> & {
  appliedAt: Date;
  guidelineUrl: string;
  penaltyPoint?: number;
  status: PostCampaignStatus;
  submitLimitTime: Date;
  isGuidelineUpdated: boolean;
  postViewingRecordUuid: string;
};
export type GetPostCampaignOverviewRes = {
  campaigns: Overview[];
};

export const getPostCampaignOverview = async (
  params: GetPostCampaignOverviewReq,
): Promise<GetPostCampaignOverviewRes> => {
  const { accountUuid } = params;
  const { data: response } = await serviceApi.viewing.getPostViewingOverview(
    withServiceRequestDefaults({
      snsAccountUuid: accountUuid,
    }),
  );

  return { campaigns: dtoToDomain(response.data) };
};

const dtoToDomain = (data: GetPostViewingOverviewResponseDto[]): Overview[] => {
  return data.map(
    ({
      createdAt,
      description,
      failReason,
      penaltyPoint,
      rewardPoint,
      status,
      submitLimitTime,
      title,
      postCampaignUuid,
      guidelineUrl,
      isGuidelineUpdated,
      postViewingRecordUuid,
      ...options
    }) => {
      return {
        appliedAt: dayjs(createdAt).toDate(),
        campaignName: title,
        campaignUuid: postCampaignUuid,
        description,
        guidelineUrl,
        rewardPoint,
        status: serverStatusMapToClientStatus(status, failReason),
        submitLimitTime: dayjs(submitLimitTime).toDate(),
        postViewingRecordUuid,
        isGuidelineUpdated,
        ...(penaltyPoint && { penaltyPoint }),
        options: {
          text: options?.minimumContentLength,
          picture: options?.minimumImageCount,
          ...(options?.containsVideos && { video: true }),
          keyword: true,
          hashTag: true,
          ...(options?.containsPlace && { place: true }),
          ...(options?.containsLink && { link: true }),
        },
      };
    },
  );
};
